import React from "react";
import PropTypes from 'prop-types';
import { ActivityIndicator, StatusBar, View } from "react-native";
import { blendColor } from '../../utils/BlendColor';

// Consts and Libs
import { AppStyles } from "../../theme/index";

// Components
import Spacer from "./Spacer";
import Text from "./Text";

const LoadingView = ({ text, barStyle, barColor }) => (
        <View style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
                      backgroundColor: 'rgba(0,0,0,0.1)', alignItems: 'center', justifyContent: 'center'}}>
        {barColor ? (<StatusBar barStyle={barStyle} backgroundColor={blendColor(barColor, 'rgba(0,0,0,0.1)')}/>) : null}
        <View style={{height: 120, paddingLeft: 30, paddingRight: 30,
                      borderRadius: 10, backgroundColor: 'rgba(0,0,0,0.5)'}}>
        <View style={[
            AppStyles.container,
            AppStyles.containerCentered,
            { backgroundColor: "transparent" },
        ]}>
        <ActivityIndicator animating size={"large"} color={"#fff"}/>
        <Spacer size={10} />
        {!!text && <Text style={{color: '#fff'}}>{text}</Text>}
    </View>
        </View>
        </View>
);

LoadingView.propTypes = { text: PropTypes.string };
LoadingView.defaultProps = { text: null };
LoadingView.componentName = "LoadingView";

export default LoadingView;
